import * as React from 'react';
import { FC } from 'react';

import { Mutable } from '@rbi-ctg/frontend';
import MainHero from 'components/features/components/main-hero';
import LoyaltyHero from 'components/features/components/main-hero/loyalty-hero';
import { IHeroMaskCardFragment, IImageFragment, IMainHeroFragment } from 'generated/sanity-graphql';
import useMediaQuery from 'hooks/use-media-query';
import { useAuthContext } from 'state/auth';

export const MainHeroContainer: FC<{ item: IMainHeroFragment }> = ({ item }) => {
  const isMobile = useMediaQuery('mobile');
  const { isAuthenticated } = useAuthContext();
  const isUserAuthenticated = isAuthenticated();

  if (isMobile && isUserAuthenticated) {
    return (
      <LoyaltyHero
        actionTo={item?.loyaltyAction?.route || ''}
        heroActionText={item?.loyaltyAction?.actionText?.locale || ''}
      />
    );
  }

  return item?.image?.locale ? (
    <MainHero
      image={item?.image?.locale}
      mobileImage={item?.mobileImage?.locale as IImageFragment}
      html={item?.mainText?.locale || ''}
      actionTo={item?.action?.route || ''}
      heroTextColor={item.textColor}
      heroActionText={item?.action?.actionText?.locale || ''}
      heroSuperText={item?.superText?.locale || ''}
      heroSubText={item?.subText?.locale || ''}
      heroMaskCards={(item.maskCards || []) as Mutable<IHeroMaskCardFragment[]>}
      heroActionLeft={item?.actionLeft?.actionText?.locale || ''}
      heroActionLeftLink={item?.actionLeft?.route || ''}
      heroActionLeftIcon={item?.actionLeftIcon?.locale}
      heroActionRight={item?.actionRight?.actionText?.locale || ''}
      heroActionRightLink={item?.actionRight?.route || ''}
      heroActionRightIcon={item?.actionRightIcon?.locale}
    />
  ) : null;
};
